import {ApiResponseInterface} from "../../interfaces/catalog/ApiResponseInterface";
import {RANGE_DELIMITER} from "../core/Range";
import {useDebounce} from "@uidotdev/usehooks";
import {CatalogFilterInterface} from "../../interfaces/catalog/CatalogFilterInterface";
import {DEFAULT_SORT, SortType, sortProducts} from "../../utils/productSort";

export default function useCatalog(response: ApiResponseInterface|undefined, filters: CatalogFilterInterface, productsPerPage: number, page: number, additionalPages: number, sortType: SortType = DEFAULT_SORT ) {

    const debouncedFilters = useDebounce(filters, 500);

    const  getFilteredProducts = () => {
        if (!response?.products || response?.products.length === 0) {
            return [];
        }

        let filteredProducts = response.products;


        const filters = debouncedFilters

        if (filters.price.min > 0 || filters.price.max > 0) {
            filteredProducts = filteredProducts.filter(product => {
                return (product.client_price || product.current_price).amount / 100 >= filters.price.min && (product.client_price || product.current_price).amount / 100 <= filters.price.max;
            });
        }


        if (filters.brands.length > 0) {
            filteredProducts = filteredProducts.filter(product => {
                return filters.brands.includes(product.brand_name);
            });
        }


        if (Object.keys(filters.filters).length > 0) {
            Object.keys(filters.filters).forEach((filterIdString: string) => {
                const filterId = parseInt(filterIdString); // Convert string to number
                const filterValues = filters.filters[filterId];

                if (filterValues.length === 1 && filterValues[0].indexOf(RANGE_DELIMITER) > -1) {
                    filteredProducts = filteredProducts.filter(product => {
                        if (!(product.properties[filterId])) {
                            return false
                        }
                        const productProperty = parseFloat(product.properties[filterId][0]);
                        const [min, max] = filterValues[0].split(RANGE_DELIMITER).map(Number);
                        return productProperty >= min && productProperty <= max;
                    });


                } else {
                    if (filterValues && filterValues.length > 0) {
                        filteredProducts = filteredProducts.filter(product => {
                            const productProperties = product.properties[filterId];
                            if (!productProperties) {
                                return false;
                            }
                            return filterValues.some(filterValue => productProperties.includes(filterValue));
                        });
                    }
                }

            });
        }

        return sortProducts(filteredProducts, sortType);
    }

    const getProductsOnPage = () => {
        return getFilteredProducts().slice((page - 1) * productsPerPage, (page + additionalPages) * productsPerPage) || [];
    }

    const getUniqueBrands = () => {
        return response?.products.map(product => product.brand_name)
            .filter((brand, index, self) => self.indexOf(brand) === index)
            .sort((a, b) => a.localeCompare(b));
    }

    const getPriceFilter = () => {
        const prices = response?.products.map(product => (product.client_price || product.current_price).amount / 100).filter(price => price > 0);
        return prices?.length ? {min: Math.floor(Math.min(...prices)) || 0, max: Math.ceil(Math.max(...prices)) || 0} : {min: 0, max: 0};
    }



    return {getFilteredProducts, getProductsOnPage, getUniqueBrands, getPriceFilter};

}